"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rafTimeoutInterval = exports.memoize = void 0;
var memoize_1 = require("./memoize");
Object.defineProperty(exports, "memoize", { enumerable: true, get: function () { return memoize_1.memoize; } });
var rafTimeoutInterval_1 = require("./rafTimeoutInterval");
Object.defineProperty(exports, "rafTimeoutInterval", { enumerable: true, get: function () { return rafTimeoutInterval_1.rafTimeoutInterval; } });
//# sourceMappingURL=index.js.map